import React from "react";
import clsx from "clsx";
import { makeStyles, Grid, Paper, Button } from "@material-ui/core";
import CommentIcon from '@material-ui/icons/Comment';
import ReTweet from "./retweet";
import Keyword from "./keyword";
import Contributors from "./contributors";
import Chart from "./graph";
import Usage from "./usage";
import PieChart from "./PieChart";
import DatePickers from "Components/DatePickers";
import DateSinglePicker from "Components/DateSinglePicker";
import DateTimePicker from "Components/DateTimePicker";
import PosiNegaTable from "./posiNegaTable";
import DataDownloads from "Components/DataDownloads";
import PosiTabs from "Components/PosiTabs";

import { withRouter } from "react-router";

import Layout from "Layout";
import useAuth from "Hooks/useAuth";
import useApi from "Hooks/useApi";
import useFilter from "Hooks/useFilter";
import googleAnalytics from "fuction/googleAnalytics";
import {useQueryString} from "Hooks/useQueryString";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 300,
  },
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
}));

function DashBoard(props) {
  const { request, convertQueryParam } = useApi();
  const auth = useAuth();
  const filter = useFilter();
  const target = props.target;
  const queryParams = useQueryString();

  const [tweets, setTweets] = React.useState([]);
  const [tweetMeta, setTweetMeta] = React.useState({});
  const [retweets, setRetweets] = React.useState([]);
  const [returnRetweets, setReturnRetweets] = React.useState(false);
  const [posiNega, setPosiNega] = React.useState([]);
  const [users, setUsers] = React.useState([]);
  const [returnUsers, setReturnUsers] = React.useState(false);
  const [keywords, setKeywords] = React.useState([]);
  const [returnKeywords, setReturnKeywords] = React.useState(false);
  const [totalCount, setTotalCount] = React.useState(0);
  const [currentLimit, setCurrentLimit] = React.useState(0);
  const [releaseLimit, setReleaseLimit] = React.useState(0);

  const fetchData = () => {
    if (auth.state.activeGroup === 0) {
      return;
    }
    // 戻るボタンやURL直貼りで遷移してきたとき、queryParams と auth.state の activeGroup が食い違っていても、
    // 初回レンダでは state の activeGroup （デフォルトグループ）でリクエストして返されたデータで画面表示されてしまう。
    // Layout.js で queryParams と auth.state の activeGroup の同期をとったあとで走る再レンダ時のリクエストで
    // 後からデータを取得しても画面に反映されない（set○○(●●)までで再々レンダは走らない）ので、
    // 同期前で食い違いがあるうちはリクエストしない。
    const activeGroup = queryParams.get("activeGroup");
    if (activeGroup && auth.state.activeGroup !== parseInt(activeGroup, 10)) {
      return;
    }

    const params = {
      unit: props.unit,
      range: [props.fromDate, props.toDate],
      filter: {
        pn: filter.state.posiNegaTab,
      },
    };
    const retweet = {
      range: [props.fromDate, props.toDate],
      filter: {
        pn: filter.state.posiNegaTab,
      },
      pagination: {
        page: "1",
        limit: "10",
      },
    };
    const usersParams = {
      range: [props.fromDate, props.toDate],
      filter: {
        pn: filter.state.posiNegaTab,
      },
      order: "asc",
      pagination: {
        page: "1",
        limit: "10",
      },
    };

    // チャートグラフ用ツイート情報取得
    request({
      method: "GET",
      url: `data/:account_id/tweets/${
        auth.state.activeGroup
      }?${convertQueryParam(params)}`,
    }).then((tweets) => {
      setTweets(tweets.data);
      setTweetMeta(tweets.meta);
    });

    // 話題情報取得
    request({
      method: "GET",
      url: `data/:account_id/retweets/${
        auth.state.activeGroup
      }/ranking?${convertQueryParam(retweet)}`,
    }).then((retweets) => {
      setReturnRetweets(true);
      setRetweets(retweets.data);
    });

    // ポジネガ円グラフ情報取得
    request({
      method: "GET",
      url: `data/:account_id/tweets/${
        auth.state.activeGroup
      }/posi_nega?${convertQueryParam(retweet)}`,
    }).then((posiNega) => {
      setPosiNega(posiNega.data);
    });

    // 投稿者情報取得
    request({
      method: "GET",
      url: `data/:account_id/users/${
        auth.state.activeGroup
      }/ranking?${convertQueryParam(usersParams)}`,
    }).then((users) => {
      setReturnUsers(true);
      setUsers(users.data);
    });

    // キーワード情報取得
    request({
      method: "GET",
      url: `data/:account_id/keywords/${
        auth.state.activeGroup
      }/ranking?${convertQueryParam(usersParams)}`,
    }).then((keywords) => {
      setReturnKeywords(true);
      setKeywords(keywords.data);
    });

    // フィルタホース情報取得
    request({
      method: "POST",
      url: `config/:account_id/account`,
      data: {
        "attrs": [
          "max_current",
          "total_count",
          "release",
        ]
      },
    }).then((filterhorse) => {
      setTotalCount(filterhorse.data.total_count);
      setCurrentLimit(filterhorse.data.max_current);
      setReleaseLimit(filterhorse.data.release);
    });
  };
  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  React.useEffect(() => {
    fetchData();
  }, [auth.state.activeGroup, filter.state, props.fromDate]);

  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  const HeadDate = () => {
    if (target === "monthly") {
      return (
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            alignItems="flex-end"
            justifyContent="flex-start"
          >
            <DatePickers onChange={fetchData} />
            <div className={classes.divider}></div>
            <PosiTabs onChangeTab={fetchData} />
          </Grid>
          <Grid container spacing={3} className={classes.formControl} justifyContent="flex-end">
            <DataDownloads
              tweets={tweets}
              retweets={retweets}
              users={users}
              keywords={keywords}
              from={props.fromDate}
              to={props.toDate}
              group={auth.state.groups.find(
                (group) => group.id === auth.state.activeGroup
              )}
            />
          </Grid>
        </Grid>
      );
    }
    if (target === "daily") {
      return (
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            alignItems="flex-end"
            justifyContent="flex-start"
          >
            <DateSinglePicker
              date={props.fromDate}
              onChange={(date) => props.handleChangeDateSingle(date)}
            />
            <div className={classes.divider}></div>
            <PosiTabs onChangeTab={fetchData} />
          </Grid>
        </Grid>
      );
    }
    if (target === "hourly") {
      return (
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            alignItems="flex-end"
            justifyContent="flex-start"
          >
            <DateTimePicker
              dateTime={props.fromDate}
              handleDateChange={props.handleDateChange}
              step={60}
            />
            <div className={classes.divider}></div>
            <PosiTabs onChangeTab={fetchData} />
          </Grid>
        </Grid>
      );
    }
  };

  return (
    <Layout
      content={
        <Grid container spacing={3}>
          <Usage
            totalCount={totalCount}
            currentLimit={currentLimit}
            releaseLimit={releaseLimit}
          />
          <HeadDate />
          <Grid item xs={12}>
            <Paper className={fixedHeightPaper}>
              <Chart
                data={tweets}
                meta={tweetMeta}
                target={target}
                dataKey={props.unit}
                onClick={(date) => props.onClickLineChart(date)}
              />
              <Grid container justifyContent="flex-end">
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={<CommentIcon />}
                  onClick={() => props.onClickListButton(props.fromDate)}
                >
                  投稿一覧
                </Button>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={6}>
            <Paper className={classes.paper}>
              <ReTweet
                content={retweets}
                isApiReturn={returnRetweets}
                handleClickRow={(id) => props.onClickReTweet(id, props.fromDate)}
              />
            </Paper>
          </Grid>
          <Grid item xs={6}>
            <PieChart {...posiNega} />
            <PosiNegaTable {...posiNega} />
          </Grid>
          <Grid item xs={6}>
            <Paper className={classes.paper}>
              <Keyword
                content={keywords}
                isApiReturn={returnKeywords}
                handleClickRow={(word) => {
                  props.onClickKeyword(word, props.fromDate);
                }}
              />
            </Paper>
          </Grid>
          <Grid item xs={6}>
            <Paper className={classes.paper}>
              <Contributors
                content={users}
                isApiReturn={returnUsers}
                handleClickRow={(screen_name) => props.onClickUser(screen_name)}
              />
            </Paper>
          </Grid>
        </Grid>
      }
    />
  );
}

export default withRouter(DashBoard);
